/* tslint:disable */
/* eslint-disable */
/* @relayHash ca4a172c3c3cdc7eb849aff97a2e96a8 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_DelegatesProfile_QueryVariables = {
    uuid: string;
};
export type App_DelegatesProfile_QueryResponse = {
    readonly delegate: {
        readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_delegate">;
    } | null;
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_manager">;
    } | null;
};
export type App_DelegatesProfile_Query = {
    readonly response: App_DelegatesProfile_QueryResponse;
    readonly variables: App_DelegatesProfile_QueryVariables;
};



/*
query App_DelegatesProfile_Query(
  $uuid: UUID!
) {
  delegate(uuid: $uuid) {
    ...DelegateProfilePage_delegate
  }
  manager {
    ...DelegateProfilePage_manager
  }
}

fragment BackgroundCheckCard_delegate on Delegate {
  uuid
  firstName
  lastName
  email
  profileImageUrl
  backgroundCheckPending
  hasActiveBackgroundCheck
  backgroundChecks {
    uuid
    approvalDate
    expiresAt
    isRenewal
    isVerification
    isCAA
    idExpiryDate
    dbsExpiryDate
    onlyDBS
    interviewNotes {
      yourName
    }
  }
}

fragment BackgroundCheckCard_manager on Manager {
  firstName
  lastName
  company {
    backgroundCheckPennyPrice
    dbsPennyPrice
    dbsOnlyPennyPrice
    renewalPennyPrice
    name
    verificationSuccessPennyPrice
    verificationFailurePennyPrice
    invoicing {
      dbsUsed
      dbsPrePurchased
      backgroundChecksUsed
      backgroundChecksPrePurchased
      renewalsUsed
      renewalsPrePurchased
    }
  }
}

fragment CourseTable_delegate on Delegate {
  myCourses {
    status
    expiresAt
    enrolledAt
    certificateURL
    progress {
      total
      completed
    }
    partTwo {
      status
      certificateURL
      expiresAt
    }
    course {
      __typename
      name
      category {
        name
      }
      ... on OnlineCourse {
        partTwo {
          __typename
          ident: id
        }
      }
    }
  }
  myClassroomCourses {
    status
    expiresAt
    enrolledAt
    certificateURL
    course {
      __typename
      ident: id
      name
      category {
        name
      }
    }
  }
}

fragment DelegateProfilePage_delegate on Delegate {
  uuid
  firstName
  lastName
  email
  jobTitle
  TTC_ID
  profileImageUrl
  currentBackgroundCheck {
    idExpiryDate
    dbsExpiryDate
  }
  hasActiveBackgroundCheck
  backgroundCheckPending
  backgroundChecks {
    uuid
    approvalDate
    isVerification
  }
  company {
    name
  }
  hasSimulatorAccess
  ...CourseTable_delegate
  ...DocumentsTable_delegate
  ...ProfileCard_delegate
  ...BackgroundCheckCard_delegate
  ...PendingBackgroundCheckTab_delegate
}

fragment DelegateProfilePage_manager on Manager {
  ...BackgroundCheckCard_manager
}

fragment DocumentsTable_delegate on Delegate {
  currentBackgroundCheck {
    idExpiryDate
    dbsExpiryDate
  }
  documents {
    edges {
      uuid
      name
      url
      expiryDate
      completionDate
      getEmail
    }
  }
}

fragment PendingBackgroundCheckTab_delegate on Delegate {
  hasActiveBackgroundCheck
  backgroundChecks {
    uuid
    createdAt
    approvalDate
    applicationSentAt
    applicationReceivedAt
    hasAllResponses
    requestedDBS
    isRenewal
    isVerification
    isCAA
    onlyDBS
    idExpiryDate
    dbsExpiryDate
    interviewNotes {
      yourName
    }
    history {
      ...Timeline_history
      uuid
      isArchived
      responseSendLogs {
        emailAddress
        sentAt
      }
      employer {
        uuid
        application {
          uuid
          name
          contactEmail
          jobTitle
          dates {
            startDate
            endDate
          }
        }
        response {
          uuid
          orgName
          orgContactName
          datesEmployed {
            startDate
            endDate
          }
        }
      }
      education {
        uuid
        application {
          uuid
          name
          contactEmail
          dates {
            startDate
            endDate
          }
        }
        response {
          uuid
          orgName
          orgContactName
          dates {
            startDate
            endDate
          }
        }
      }
      selfEmployed {
        uuid
        application {
          uuid
          accountantName
          contactEmail
          dates {
            startDate
            endDate
          }
        }
        response {
          uuid
          orgName
          orgContactName
          dates {
            startDate
            endDate
          }
        }
      }
      unemployed {
        uuid
        application {
          uuid
          dates {
            startDate
            endDate
          }
        }
        response {
          uuid
          alternateDates {
            startDate
            endDate
          }
        }
      }
    }
  }
}

fragment ProfileCard_delegate on Delegate {
  email
  TTC_ID
  jobTitle
  telephone
}

fragment Timeline_history on BackgroundHistory {
  uuid
  isArchived
  responseSendLogs {
    sentAt
    emailAddress
  }
  employer {
    uuid
    responseLink
    application {
      uuid
      name
      contactEmail
      jobTitle
      reasonForLeaving
      dates {
        startDate
        endDate
      }
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
      absent
    }
    response {
      uuid
      datesEmployed {
        startDate
        endDate
      }
      positionsHeld
      reasonForLeaving
      wouldEmploy
      wouldEmployReason
      absence
      datesAbsent {
        startDate
        endDate
      }
      otherInformation
      orgName
      orgContactName
      orgJobTitle
      orgTelephone
      orgAddress {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
  education {
    uuid
    responseLink
    application {
      uuid
      name
      contactEmail
      dates {
        startDate
        endDate
      }
      examsTaken
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
    response {
      uuid
      dates {
        startDate
        endDate
      }
      courseDetails
      examResults
      otherInformation
      orgName
      orgContactName
      orgJobTitle
      orgTelephone
      orgAddress {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
  unemployed {
    uuid
    responseLink
    application {
      uuid
      dates {
        startDate
        endDate
      }
      reasonForUnemployment
      hadBenefits
    }
    response {
      uuid
      datesAccurate
      alternateDates {
        startDate
        endDate
      }
      lengthKnown
      relation
      inUK
      travelDetails
      employed
      employedDetails
      whereLived
      whatDoing
      financialSupport
      lacksIntegrity
      integrityDetail
      otherInformation
      occupation
      unavailableFrom
      firstName
      lastName
      daytimeTelephone
      homeTelephone
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
  selfEmployed {
    uuid
    responseLink
    application {
      uuid
      accountantName
      contactEmail
      dates {
        startDate
        endDate
      }
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
    response {
      uuid
      dates {
        startDate
        endDate
      }
      selfEmploymentDetails
      businessName
      tradingName
      lacksIntegrity
      integrityDetail
      otherInformation
      orgName
      orgContactName
      orgJobTitle
      orgTelephone
      orgAddress {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "uuid",
            "variableName": "uuid"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "jobTitle",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "idExpiryDate",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "dbsExpiryDate",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expiresAt",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "responseLink",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contactEmail",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "reasonForLeaving",
        "args": null,
        "storageKey": null
    } as any), v13 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "startDate",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "endDate",
            "args": null,
            "storageKey": null
        } as any)
    ], v14 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "dates",
        "storageKey": null,
        "args": null,
        "concreteType": "HistoryDates",
        "plural": true,
        "selections": (v13 /*: any*/)
    } as any), v15 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine1",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine2",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "county",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "postCode",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "country",
            "args": null,
            "storageKey": null
        } as any)
    ], v16 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "address",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v15 /*: any*/)
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "otherInformation",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgName",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgContactName",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgJobTitle",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgTelephone",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "orgAddress",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v15 /*: any*/)
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lacksIntegrity",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "integrityDetail",
        "args": null,
        "storageKey": null
    } as any), v25 = [
        (v10 /*: any*/)
    ], v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrolledAt",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "certificateURL",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": (v25 /*: any*/)
    } as any), v31 = ({
        "kind": "ScalarField",
        "alias": "ident",
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_DelegatesProfile_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Delegate",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "DelegateProfilePage_delegate",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "DelegateProfilePage_manager",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_DelegatesProfile_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Delegate",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        (v5 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "TTC_ID",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "profileImageUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentBackgroundCheck",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BackgroundCheck",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                (v7 /*: any*/)
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasActiveBackgroundCheck",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "backgroundCheckPending",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "backgroundChecks",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BackgroundCheck",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "approvalDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isVerification",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v8 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isRenewal",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isCAA",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "onlyDBS",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "interviewNotes",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "InterviewNotes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "yourName",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "createdAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "applicationSentAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "applicationReceivedAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasAllResponses",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "requestedDBS",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "history",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BackgroundHistory",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isArchived",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "responseSendLogs",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ResponseSendLog",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "sentAt",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "emailAddress",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "employer",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundHistoryEmployer",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "application",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckEmployerApplication",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v16 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "absent",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "response",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckEmployerResponse",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "datesEmployed",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "HistoryDates",
                                                            "plural": true,
                                                            "selections": (v13 /*: any*/)
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "positionsHeld",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v12 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "wouldEmploy",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "wouldEmployReason",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "absence",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "datesAbsent",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "HistoryDates",
                                                            "plural": true,
                                                            "selections": (v13 /*: any*/)
                                                        },
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "education",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundHistoryEducation",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "application",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckEducationApplication",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v14 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "examsTaken",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v16 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "response",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckEducationResponse",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v14 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "courseDetails",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "examResults",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "unemployed",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundHistoryUnemployed",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "application",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckUnemployedApplication",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v14 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "reasonForUnemployment",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "hadBenefits",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "response",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckUnemployedResponse",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "datesAccurate",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "alternateDates",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "HistoryDates",
                                                            "plural": true,
                                                            "selections": (v13 /*: any*/)
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "lengthKnown",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "relation",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "inUK",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "travelDetails",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "employed",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "employedDetails",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "whereLived",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "whatDoing",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "financialSupport",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v23 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "occupation",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "unavailableFrom",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/),
                                                        (v4 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "daytimeTelephone",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "homeTelephone",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v16 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "selfEmployed",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundHistorySelfEmployed",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "application",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckSelfEmployedApplication",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "accountantName",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v11 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v16 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "response",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "BackgroundCheckSelfEmploymentResponse",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v14 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "selfEmploymentDetails",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "businessName",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "tradingName",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v23 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": (v25 /*: any*/)
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasSimulatorAccess",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "myCourses",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MyCourse",
                            "plural": true,
                            "selections": [
                                (v26 /*: any*/),
                                (v8 /*: any*/),
                                (v27 /*: any*/),
                                (v28 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "progress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Progress",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "total",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "completed",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "partTwo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MyCourse",
                                    "plural": false,
                                    "selections": [
                                        (v26 /*: any*/),
                                        (v28 /*: any*/),
                                        (v8 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "course",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v29 /*: any*/),
                                        (v10 /*: any*/),
                                        (v30 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "OnlineCourse",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "partTwo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "plural": false,
                                                    "selections": [
                                                        (v29 /*: any*/),
                                                        (v31 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "myClassroomCourses",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MyCourse",
                            "plural": true,
                            "selections": [
                                (v26 /*: any*/),
                                (v8 /*: any*/),
                                (v27 /*: any*/),
                                (v28 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "course",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v29 /*: any*/),
                                        (v31 /*: any*/),
                                        (v10 /*: any*/),
                                        (v30 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentPage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Document",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "url",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expiryDate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "completionDate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "getEmail",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "telephone",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "backgroundCheckPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dbsPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dbsOnlyPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "renewalPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v10 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "verificationSuccessPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "verificationFailurePennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "invoicing",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CompanyInvoicing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "dbsUsed",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "dbsPrePurchased",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "backgroundChecksUsed",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "backgroundChecksPrePurchased",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "renewalsUsed",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "renewalsPrePurchased",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_DelegatesProfile_Query",
            "id": null,
            "text": "query App_DelegatesProfile_Query(\n  $uuid: UUID!\n) {\n  delegate(uuid: $uuid) {\n    ...DelegateProfilePage_delegate\n  }\n  manager {\n    ...DelegateProfilePage_manager\n  }\n}\n\nfragment BackgroundCheckCard_delegate on Delegate {\n  uuid\n  firstName\n  lastName\n  email\n  profileImageUrl\n  backgroundCheckPending\n  hasActiveBackgroundCheck\n  backgroundChecks {\n    uuid\n    approvalDate\n    expiresAt\n    isRenewal\n    isVerification\n    isCAA\n    idExpiryDate\n    dbsExpiryDate\n    onlyDBS\n    interviewNotes {\n      yourName\n    }\n  }\n}\n\nfragment BackgroundCheckCard_manager on Manager {\n  firstName\n  lastName\n  company {\n    backgroundCheckPennyPrice\n    dbsPennyPrice\n    dbsOnlyPennyPrice\n    renewalPennyPrice\n    name\n    verificationSuccessPennyPrice\n    verificationFailurePennyPrice\n    invoicing {\n      dbsUsed\n      dbsPrePurchased\n      backgroundChecksUsed\n      backgroundChecksPrePurchased\n      renewalsUsed\n      renewalsPrePurchased\n    }\n  }\n}\n\nfragment CourseTable_delegate on Delegate {\n  myCourses {\n    status\n    expiresAt\n    enrolledAt\n    certificateURL\n    progress {\n      total\n      completed\n    }\n    partTwo {\n      status\n      certificateURL\n      expiresAt\n    }\n    course {\n      __typename\n      name\n      category {\n        name\n      }\n      ... on OnlineCourse {\n        partTwo {\n          __typename\n          ident: id\n        }\n      }\n    }\n  }\n  myClassroomCourses {\n    status\n    expiresAt\n    enrolledAt\n    certificateURL\n    course {\n      __typename\n      ident: id\n      name\n      category {\n        name\n      }\n    }\n  }\n}\n\nfragment DelegateProfilePage_delegate on Delegate {\n  uuid\n  firstName\n  lastName\n  email\n  jobTitle\n  TTC_ID\n  profileImageUrl\n  currentBackgroundCheck {\n    idExpiryDate\n    dbsExpiryDate\n  }\n  hasActiveBackgroundCheck\n  backgroundCheckPending\n  backgroundChecks {\n    uuid\n    approvalDate\n    isVerification\n  }\n  company {\n    name\n  }\n  hasSimulatorAccess\n  ...CourseTable_delegate\n  ...DocumentsTable_delegate\n  ...ProfileCard_delegate\n  ...BackgroundCheckCard_delegate\n  ...PendingBackgroundCheckTab_delegate\n}\n\nfragment DelegateProfilePage_manager on Manager {\n  ...BackgroundCheckCard_manager\n}\n\nfragment DocumentsTable_delegate on Delegate {\n  currentBackgroundCheck {\n    idExpiryDate\n    dbsExpiryDate\n  }\n  documents {\n    edges {\n      uuid\n      name\n      url\n      expiryDate\n      completionDate\n      getEmail\n    }\n  }\n}\n\nfragment PendingBackgroundCheckTab_delegate on Delegate {\n  hasActiveBackgroundCheck\n  backgroundChecks {\n    uuid\n    createdAt\n    approvalDate\n    applicationSentAt\n    applicationReceivedAt\n    hasAllResponses\n    requestedDBS\n    isRenewal\n    isVerification\n    isCAA\n    onlyDBS\n    idExpiryDate\n    dbsExpiryDate\n    interviewNotes {\n      yourName\n    }\n    history {\n      ...Timeline_history\n      uuid\n      isArchived\n      responseSendLogs {\n        emailAddress\n        sentAt\n      }\n      employer {\n        uuid\n        application {\n          uuid\n          name\n          contactEmail\n          jobTitle\n          dates {\n            startDate\n            endDate\n          }\n        }\n        response {\n          uuid\n          orgName\n          orgContactName\n          datesEmployed {\n            startDate\n            endDate\n          }\n        }\n      }\n      education {\n        uuid\n        application {\n          uuid\n          name\n          contactEmail\n          dates {\n            startDate\n            endDate\n          }\n        }\n        response {\n          uuid\n          orgName\n          orgContactName\n          dates {\n            startDate\n            endDate\n          }\n        }\n      }\n      selfEmployed {\n        uuid\n        application {\n          uuid\n          accountantName\n          contactEmail\n          dates {\n            startDate\n            endDate\n          }\n        }\n        response {\n          uuid\n          orgName\n          orgContactName\n          dates {\n            startDate\n            endDate\n          }\n        }\n      }\n      unemployed {\n        uuid\n        application {\n          uuid\n          dates {\n            startDate\n            endDate\n          }\n        }\n        response {\n          uuid\n          alternateDates {\n            startDate\n            endDate\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProfileCard_delegate on Delegate {\n  email\n  TTC_ID\n  jobTitle\n  telephone\n}\n\nfragment Timeline_history on BackgroundHistory {\n  uuid\n  isArchived\n  responseSendLogs {\n    sentAt\n    emailAddress\n  }\n  employer {\n    uuid\n    responseLink\n    application {\n      uuid\n      name\n      contactEmail\n      jobTitle\n      reasonForLeaving\n      dates {\n        startDate\n        endDate\n      }\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n      absent\n    }\n    response {\n      uuid\n      datesEmployed {\n        startDate\n        endDate\n      }\n      positionsHeld\n      reasonForLeaving\n      wouldEmploy\n      wouldEmployReason\n      absence\n      datesAbsent {\n        startDate\n        endDate\n      }\n      otherInformation\n      orgName\n      orgContactName\n      orgJobTitle\n      orgTelephone\n      orgAddress {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n  education {\n    uuid\n    responseLink\n    application {\n      uuid\n      name\n      contactEmail\n      dates {\n        startDate\n        endDate\n      }\n      examsTaken\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n    response {\n      uuid\n      dates {\n        startDate\n        endDate\n      }\n      courseDetails\n      examResults\n      otherInformation\n      orgName\n      orgContactName\n      orgJobTitle\n      orgTelephone\n      orgAddress {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n  unemployed {\n    uuid\n    responseLink\n    application {\n      uuid\n      dates {\n        startDate\n        endDate\n      }\n      reasonForUnemployment\n      hadBenefits\n    }\n    response {\n      uuid\n      datesAccurate\n      alternateDates {\n        startDate\n        endDate\n      }\n      lengthKnown\n      relation\n      inUK\n      travelDetails\n      employed\n      employedDetails\n      whereLived\n      whatDoing\n      financialSupport\n      lacksIntegrity\n      integrityDetail\n      otherInformation\n      occupation\n      unavailableFrom\n      firstName\n      lastName\n      daytimeTelephone\n      homeTelephone\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n  selfEmployed {\n    uuid\n    responseLink\n    application {\n      uuid\n      accountantName\n      contactEmail\n      dates {\n        startDate\n        endDate\n      }\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n    response {\n      uuid\n      dates {\n        startDate\n        endDate\n      }\n      selfEmploymentDetails\n      businessName\n      tradingName\n      lacksIntegrity\n      integrityDetail\n      otherInformation\n      orgName\n      orgContactName\n      orgJobTitle\n      orgTelephone\n      orgAddress {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b475005acf7f5785516a8b99eb2dfde2';
export default node;
